const Globe = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 8H15.5M0.5 8C0.5 12.1421 3.85786 15.5 8 15.5M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5M15.5 8C15.5 3.85786 12.1421 0.5 8 0.5M8 0.5C9.87596 2.55376 10.9421 5.21903 11 8C10.9421 10.781 9.87596 13.4462 8 15.5M8 0.5C6.12404 2.55376 5.05794 5.21903 5 8C5.05794 10.781 6.12404 13.4462 8 15.5"
      stroke="#A4A7AE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Globe;
